import { defineComponent as _defineComponent } from 'vue'
import { useDialogStore } from "@/store/dialogs";
import { ref, onMounted, watch, nextTick } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomDialogs',
  setup(__props) {

const dialogStore = useDialogStore();
const dialogRefs = ref<{ [key: number]: HTMLDialogElement }>({});

const closeDialog = (index: number) => {
  const dialog = dialogRefs.value[index];
  if (dialog) {
    dialog.close();
    dialogStore.removeDialog(index);
  }
};

onMounted(() => {
  document.addEventListener("click", (event) => {
    Object.entries(dialogRefs.value).forEach(([index, dialog]) => {
      if (dialog.open) {
        const rect = dialog.getBoundingClientRect();
        const isInDialog =
          rect.top <= event.clientY &&
          event.clientY <= rect.top + rect.height &&
          rect.left <= event.clientX &&
          event.clientX <= rect.left + rect.width;
        if (!isInDialog) {
          closeDialog(Number(index));
        }
      }
    });
  });
});

watch(
  () => dialogStore.dialogs,
  (newDialogs) => {
    nextTick(() => {
      newDialogs.forEach((_, index) => {
        const dialog = dialogRefs.value[index];
        if (dialog && !dialog.open) {
          dialog.showModal();
        }
      });
    });
  },
  { deep: true }
);

return { __sfc: true,dialogStore, dialogRefs, closeDialog }
}

})